let appName = process.env.VUE_APP_NAME

let appConfig = {
  primaryColor: '#242424',
  componentColor: '#fff'
}

export { appConfig, appName }
